export default __webpack_public_path__ + "static/podminky-sluzby-ea499e71a0d9d1a600238056de7faeee.pdf";